<template>
    <li :class="this.bActive ? 'active' : ''" class="mousecursor" @click="onClickAnchor" >
        <div :style="headUrlStyle" style="width:100%;height:100%;background-repeat:no-repeat;background-size:100%;"> </div>
        <div class="maskBox">{{this.info.name}}</div>
    </li>
</template>

<script>
export default {
    name:"hotThreeAnchorItem",
    computed:{
        bActive(){
            return false;
        },
        info () {
            return this.itemData
        },
        headUrlStyle(){
            return {
                "background-image": "url('" + this.info.img + "')"
            };
        }
    },
    props:{
        itemData: {
            type:Object,
            default:{}
        }
    },
    methods:{
        onClickAnchor(){
            this.$store.dispatch('roomInfo_Current_Anchor_Info',this.itemData);
            localStorage.setItem('AnchorId','' + this.itemData.id);
            localStorage.setItem('FamilyId','' + this.itemData.familyid);
            this.$store.dispatch('roomInfo_Current_Anchor_Id',this.itemData.id);
            this.$emit("onClickHotThreeAnchor", this.itemData.id);
        }
    }
}
</script>

<style>

</style>
